const t = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
export {
  t as c
};
